import { QueryResult, useQuery } from '@apollo/client'
import {
  CompanyManagerDashboardWorkforceCountersQuery,
  CompanyManagerDashboardWorkforceCountersQueryVariables,
  CompanyManagerDashboardWorkforceLeaversQuery,
  CompanyManagerDashboardWorkforceLeaversQueryVariables,
  CompanyManagerDashboardWorkforceNewEntriesQuery,
  CompanyManagerDashboardWorkforceNewEntriesQueryVariables,
  CompanyManagerDashboardWorkforceProbationPeriodEndingQuery,
  CompanyManagerDashboardWorkforceProbationPeriodEndingQueryVariables,
  RoleName,
  WorkforceMovementPeriodEnum,
} from '../../../types'
import {
  COMPANY_MANAGER_DASHBOARD_WORKFORCE_COUNTERS,
  COMPANY_MANAGER_DASHBOARD_WORKFORCE_LEAVERS,
  COMPANY_MANAGER_DASHBOARD_WORKFORCE_NEW_ENTRIES,
  COMPANY_MANAGER_DASHBOARD_WORKFORCE_PROBATION_PERIOD_ENDING,
} from '../workforce-movements/Queries'

const workforceDashboardQueryOptions = {
  fetchPolicy: 'cache-first' as const,
}

type WorkforceDetailQueryOptions = {
  skip?: boolean
}

export const useCompanyManagerDashboardWorkforceCounters = (
  companyId: string,
  userDashboardRoles: RoleName[],
): QueryResult<CompanyManagerDashboardWorkforceCountersQuery, CompanyManagerDashboardWorkforceCountersQueryVariables> => {
  return useQuery<CompanyManagerDashboardWorkforceCountersQuery, CompanyManagerDashboardWorkforceCountersQueryVariables>(
    COMPANY_MANAGER_DASHBOARD_WORKFORCE_COUNTERS,
    {
      variables: { companyId, userDashboardRoles },
      ...workforceDashboardQueryOptions,
    },
  )
}

export const useCompanyManagerDashboardWorkforceNewEntries = (
  companyId: string,
  period: WorkforceMovementPeriodEnum | null,
  userDashboardRoles: RoleName[],
  options?: WorkforceDetailQueryOptions,
): QueryResult<CompanyManagerDashboardWorkforceNewEntriesQuery, CompanyManagerDashboardWorkforceNewEntriesQueryVariables> => {
  return useQuery<CompanyManagerDashboardWorkforceNewEntriesQuery, CompanyManagerDashboardWorkforceNewEntriesQueryVariables>(
    COMPANY_MANAGER_DASHBOARD_WORKFORCE_NEW_ENTRIES,
    {
      variables: { companyId, period, userDashboardRoles },
      ...workforceDashboardQueryOptions,
      skip: options?.skip,
    },
  )
}

export const useCompanyManagerDashboardWorkforceLeavers = (
  companyId: string,
  period: WorkforceMovementPeriodEnum | null,
  userDashboardRoles: RoleName[],
  options?: WorkforceDetailQueryOptions,
): QueryResult<CompanyManagerDashboardWorkforceLeaversQuery, CompanyManagerDashboardWorkforceLeaversQueryVariables> => {
  return useQuery<CompanyManagerDashboardWorkforceLeaversQuery, CompanyManagerDashboardWorkforceLeaversQueryVariables>(
    COMPANY_MANAGER_DASHBOARD_WORKFORCE_LEAVERS,
    {
      variables: { companyId, period, userDashboardRoles },
      ...workforceDashboardQueryOptions,
      skip: options?.skip,
    },
  )
}

export const useCompanyManagerDashboardWorkforceProbationPeriodEnding = (
  companyId: string,
  period: WorkforceMovementPeriodEnum | null,
  userDashboardRoles: RoleName[],
  options?: WorkforceDetailQueryOptions,
): QueryResult<
  CompanyManagerDashboardWorkforceProbationPeriodEndingQuery,
  CompanyManagerDashboardWorkforceProbationPeriodEndingQueryVariables
> => {
  return useQuery<
    CompanyManagerDashboardWorkforceProbationPeriodEndingQuery,
    CompanyManagerDashboardWorkforceProbationPeriodEndingQueryVariables
  >(COMPANY_MANAGER_DASHBOARD_WORKFORCE_PROBATION_PERIOD_ENDING, {
    variables: { companyId, period, userDashboardRoles },
    ...workforceDashboardQueryOptions,
    skip: options?.skip,
  })
}
